module.exports = __webpack_public_path__ + "static/media/pad-technology_Sahara-Forest-Project-Foundation_crop_tablet.e355237d.jpg";